import { Route, Routes } from 'react-router-dom';
import calculatedRoutes from 'routing/calculateRoutes';

import Error404Page from 'pages/Error404Page';

const App = () => {
  return (
    <Routes>
      {calculatedRoutes()}
      <Route path={'/*'} element={<Error404Page />} />
    </Routes>
  );
};

export default App;
